module.exports = __webpack_public_path__ + "img/wishlist-2@2x.60ee4b7.png";